
import { setupTranslationPrefixer } from '~/assets/translation'

export default {
  props: {
    title: { type: String, required: false, default: '' },
    keyword: { type: String, required: false, default: '' },
    introduction: { type: String, required: false, default: '' },
  },
  setup(props, { emit }) {
    const keywordSubmit = (keyword) => {
      emit('keywordSubmit', keyword)
    }
    return {
      ...setupTranslationPrefixer('GenericSearchSearch'),
      keywordSubmit,
    }
  },
}
